import { useNavigate, useSearchParams } from "react-router-dom";
import LoadingWrapper from "../components/common/LoadingWrapper";
import { getRecentCases, getSystemAlerts, getSystemSettings, getUser, getUserWorkQueueViews } from "../lib/fetchApi";
import { notificationActions } from "../store/notifications";
import { setStorageItem } from "../lib/script";
import { clearWorkQFiltersAndRecentCases } from "../lib/filters";
import { filterActions } from "../store/filter";
import { tasksActions } from "../store/tasks";
import { permissionsActions } from "../store/permissions";
import { userActions } from "../store/user";
import { reduceToIdArray } from "../lib/script";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { systemActions } from "../store/system";

export default function TokenLoginPage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    

    useEffect(() => {
        if (searchParams?.get('token')) {
            let token = searchParams?.get('token')

            localStorage.setItem('token', token)
            const tryToGetUser = async (token) => {
                clearWorkQFiltersAndRecentCases()
                dispatch(filterActions.resetSavedViews())
                dispatch(tasksActions.resetPersistedListState())
                const [user, systemSettings, recentCases, savedViews] = await Promise.all([
                    getUser(token),
                    getSystemSettings(token),
                    getRecentCases(token),
                    getUserWorkQueueViews(token),
                ])
                setStorageItem('settings', systemSettings)
                dispatch(systemActions.bumpSettingsRevision())
            
                if (user && user.errorMessage) {
                    dispatch(notificationActions.setError(user)) 
                    navigate('/')
                } else {  

                    dispatch(permissionsActions.setEditPermissions(user.permissions))
                    setStorageItem('user', user)
                    dispatch(userActions.setUser(user))

                    if (user.locations && user.locations.length) {
                        setStorageItem('userLocations', reduceToIdArray(user?.locations))
                        dispatch(userActions.setUserLocations(reduceToIdArray(user?.locations)))
                    }

                    const systemAlerts = await getSystemAlerts(token)
                    if (systemAlerts && !systemAlerts.errorMessage) {
                        setStorageItem('persistentSystemAlerts', systemAlerts)
                        dispatch(systemActions.setSystemAlerts(systemAlerts))
                    }

                    if (recentCases && !recentCases.errorMessage) {
                        setStorageItem('recentCases', recentCases)
                    }

                    dispatch(filterActions.setSavedViews(
                        savedViews && !savedViews.errorMessage && savedViews.views
                            ? savedViews.views
                            : {}
                    ))


                    navigate(`/dashboard`, {replace: true});
                } 
            }


            tryToGetUser(token)
            
        }
    }, [searchParams]);
    return <LoadingWrapper />;
}